/**
 * 优化的 Paddle 配置
 * 包含性能优化和缓存策略
 */

// 从环境变量获取配置
export const PADDLE_CLIENT_TOKEN = import.meta.env.VITE_PADDLE_CLIENT_TOKEN || '';
export const PADDLE_ENVIRONMENT = import.meta.env.VITE_PADDLE_ENVIRONMENT || 'sandbox';
export const PADDLE_PRODUCT_ID = import.meta.env.VITE_PADDLE_PRODUCT_YEARLY || '';

// 价格信息（仅用于显示）
export const PRODUCT_PRICE = {
  amount: 9.99,
  currency: 'USD',
  period: 'year'
};

// 获取当前域名（缓存结果）
let cachedBaseUrl: string | null = null;
const getBaseUrl = () => {
  if (cachedBaseUrl) return cachedBaseUrl;
  
  if (typeof window !== 'undefined') {
    cachedBaseUrl = window.location.origin;
    return cachedBaseUrl;
  }
  return 'https://utilityapp.site';
};

// 成功和取消页面URL
export const PADDLE_CANCEL_URL = `${getBaseUrl()}/pricing?subscription_cancelled=true`;

// Paddle 优化配置
export const PADDLE_OPTIMIZATION_CONFIG = {
  // 预连接的域名
  preconnectDomains: [
    'https://cdn.paddle.com',
    'https://checkout.paddle.com',
    'https://js.paddle.com',
    'https://pay.paddle.com',
  ],
  
  // DNS 预解析域名
  dnsPrefetchDomains: [
    'https://cdn.paddle.com',
    'https://checkout.paddle.com',
    'https://js.paddle.com',
    'https://pay.paddle.com',
    'https://api.paddle.com',
  ],
  
  // 初始化超时时间（毫秒）
  initTimeout: 10000,
  
  // 重试配置
  retryConfig: {
    maxRetries: 3,
    retryDelay: 1000,
  },
  
  // 预加载策略
  preloadStrategy: {
    // 立即预加载（网站打开时）
    immediate: true,
    // 使用 requestIdleCallback 优化性能
    useIdleCallback: true,
    // 空闲回调超时时间（毫秒）
    idleTimeout: 2000,
  },
};

// 检查 Paddle 配置是否完整
export const isPaddleConfigured = (): boolean => {
  return Boolean(PADDLE_CLIENT_TOKEN && PADDLE_CLIENT_TOKEN !== 'undefined');
};

// 获取 Paddle 初始化配置
export const getPaddleInitConfig = () => ({
  token: PADDLE_CLIENT_TOKEN,
  environment: PADDLE_ENVIRONMENT as 'sandbox' | 'production',
  // 性能优化选项
  pwCustomer: undefined,  // 不预填客户信息
  pwAuth: undefined,      // 不使用认证
});